/** Русский — авторский оригинал; тип ключей выводится из этого файла. */
export const ru = {
  'lang.self': 'RU',

  'dir.as_map': 'На карте',
  'dir.as_list': 'Списком',
  'dir.map_none': 'Нет площадок с координатами',
  'dir.map_failed': 'Карта не загрузилась — попробуйте ещё раз',
  'dir.units': 'зданий',
  'dir.pois': 'точек',
  'dir.open': 'Открыть площадку',
  'venue.type.industrial_park': 'Промзона',
  'venue.type.mall': 'Торговый центр',
  'venue.type.airport': 'Аэропорт',
  'venue.type.port': 'Порт',
  'venue.type.ship': 'Судно',
  'venue.type.terminal': 'Терминал',
  'venue.type.cruise': 'Круизное судно',
  'dir.title': '{brand} — навигатор площадок',
  'dir.subtitle': 'Найдите площадку и постройте маршрут до нужной точки.',
  'dir.search': 'Поиск: название, адрес…',
  'dir.verified': 'Организация проверена',
  'dir.empty': 'Пока ничего не найдено.',
  'map.loading': 'Загружаем карту…',
  'map.error': 'Карта недоступна. Проверьте связь и обновите страницу.',
  'map.you_are_here': 'Вы здесь',
  'map.attribution': '© Данные карты · OpenMapTiles · ODbL',
  // Шапка и нижний лист ОБЗОРА (дизайн Aurora, 05.08.2026)
  'hdr.live': 'живая карта',
  'hdr.offline': 'офлайн',
  'sheet.where_to': 'Куда идёте?',
  'sheet.directory': 'все объекты',
  'sheet.ai_hints': 'ИИ подсказки',
  'target.stat_time': 'время',
  'target.stat_way': 'путь',
  'target.stat_levels': 'этажи',
  'target.stat_start': 'старт',
  'target.room_n': 'Помещение {code}',
  'route.arrival_at': 'прибытие в',
  'route.remaining': 'осталось',
  'route.turns_n': '{n} поворота',
  'orient.step_one': 'Ориентация · шаг 1',
  'orient.first_step_q': 'Куда сделать первый шаг',
  'orient.acc_precise': 'Точно · по компасу и щиту',
  'orient.acc_approx': 'Примерно · датчики телефона',
  'orient.acc_rough': 'Ориентировочно · без датчиков',
  'orient.north': 'С',
  'orient.east': 'В',
  'orient.south': 'Ю',
  'orient.west': 'З',
  'follow.arrival': 'прибытие',
  'follow.recenter': 'Вернуться к себе',
  'follow.stat_done': 'пройдено',
  'follow.stat_left': 'осталось',
  'follow.stat_steps': 'шаги',

  'cat.warehouse': 'Склад',
  'cat.checkpoint': 'КПП',
  'cat.office': 'Диспетчерская',
  'cat.dock': 'Ворота',
  'cat.truck_scale': 'Весовая',
  'cat.wc': 'Туалет',
  'cat.info': 'Инфостойка',
  'cat.entrance': 'Вход',
  'cat.food': 'Еда',
  'cat.clothing': 'Одежда',
  'cat.sport': 'Спорт',
  'cat.tech': 'Техника',
  'cat.beauty': 'Красота',
  'cat.grocery': 'Продукты',
  'cat.home': 'Дом',
  'cat.service': 'Сервис',
  'cat.loading_dock': 'Погрузочная рампа',
  'cat.parking': 'Паркинг',
  'cat.elevator': 'Лифт',
  'cat.escalator': 'Эскалатор',
  'cat.stairs': 'Лестница',

  'target.eta': '≈ {time} пешком · {dist}',
  'target.route': 'Маршрут',
  'target.no_route': 'Маршрут не найден — обратитесь на КПП',
  'target.from_entrance': 'от главного входа',
  'route.to_floor': 'На этаж {n}',
  'target.step_free': 'Путь без ступеней',
  'target.step_free_hint':
    'До этой цели есть маршрут без лестниц и ступеней — по лифту и пандусам.',

  'travel.label': 'Как добираетесь',
  'travel.foot': 'Пешком',
  'travel.vehicle': 'На авто',
  'travel.truck': 'Фура',

  'route.ext_leg': 'включая {min} мин по улицам до входа',
  'route.go': 'В путь',

  'floor.title': 'Этажи',
  'follow.remaining': 'Осталось {time} · {dist}',
  'follow.next_step': 'Дальше ✓',
  'follow.floor_up_stairs': 'Поднимитесь по лестнице на этаж {n}',
  'follow.floor_down_stairs': 'Спуститесь по лестнице на этаж {n}',
  'follow.floor_up_escalator': 'Поднимитесь на эскалаторе на этаж {n}',
  'follow.floor_down_escalator': 'Спуститесь на эскалаторе на этаж {n}',
  'follow.floor_up_elevator': 'Поднимитесь на лифте на этаж {n}',
  'follow.floor_down_elevator': 'Спуститесь на лифте на этаж {n}',
  'follow.floor_up': 'Поднимитесь на этаж {n}',
  'follow.floor_down': 'Спуститесь на этаж {n}',
  'follow.floor_confirm': 'Я на этаже {n} ✓',
  'follow.floor_wrong': 'Я ещё на этаже {n}',
  'follow.step_of': 'Шаг {k} из {n}',
  'follow.arrived': 'Вы на месте',
  'follow.arrived_in': 'Дошли за {time}',
  'follow.arrive_at': 'приход ≈ {time}',
  'follow.back_route': 'Обратный путь',
  'follow.stop': 'Завершить',
  'follow.voice_turn': 'Через {dist} поверните {dir}',
  'follow.voice_left': 'налево',
  'follow.voice_right': 'направо',
  'follow.voice_arrived': 'Вы пришли',
  'follow.alerts_silent': 'Подсказки: тихо',
  'follow.alerts_vibrate': 'Подсказки: вибрация',
  'follow.alerts_voice': 'Подсказки: голос',
  'follow.exit': 'Выйти',
  'follow.details': 'Подробности маршрута',
  'follow.collapse': 'Свернуть',
  'follow.show_panel': 'Показать панель ведения',

  'anchor.toast_hint': 'карта уже знает, где вы',
  'offline.ready': 'работает оффлайн',
  'offline.cached': 'оффлайн · карта из кеша',

  'packs.heading': 'Карты без сети',
  'packs.save_venue': '💾 Сохранить карту площадки · {mb} МБ',
  'packs.save_city': '🌍 Город без сети: {name} · {mb} МБ',
  'packs.name_venue': 'Карта площадки',
  'packs.name_city': 'Город: {name}',
  'packs.installed': '✓ Сохранено · версия {version}',
  'packs.downloading': 'Скачивание… {percent} %',
  'packs.verifying': 'Проверка файла…',
  'packs.warming': 'Догружаем шрифты и данные площадок…',
  'packs.keep_open': 'Не сворачивайте приложение — загрузка идёт только на экране',
  'packs.paused': 'Загрузка на паузе: вернитесь в приложение',
  'packs.error': 'Не получилось скачать',
  'packs.error_checksum': 'Файл пришёл повреждённым',
  'packs.error_storage': 'На устройстве нет места для карты',
  'packs.retry': 'Повторить',
  'packs.wifi_hint': 'Лучше по Wi-Fi: {mb} МБ',
  'packs.save_data': 'Включена экономия трафика — загрузка может не пройти',
  'packs.ios_install_first':
    'Сначала «Добавить на экран «Домой»» — иначе Safari сотрёт карту через 7 дней',
  'packs.ios_steps': 'Поделиться → «На экран «Домой»» → откройте {brand} с домашнего экрана',
  'dock.hint': 'можно перетащить',

  'qr.dock_label': 'Сканировать QR',
  'qr.title': 'Сканер QR',
  'qr.frame_hint': 'Наведите камеру на QR-код',
  'qr.permission_denied_title': 'Нет доступа к камере',
  'qr.permission_denied_body':
    'Разрешите камеру в настройках браузера (значок замка рядом с адресом) или сфотографируйте код.',
  'qr.permission_photo_btn': '📷 Сфотографировать QR',
  'qr.unavailable': 'В этом браузере нет доступа к камере — сфотографируйте код',
  'qr.no_code_found': 'Код на фото не найден, попробуйте снова',
  'qr.scan_again': 'Сканировать снова',
  'qr.result_external_title': 'Ссылка не с {brand}',
  'qr.result_unsafe_title': 'Небезопасная ссылка — не открываем автоматически',
  'qr.result_text_title': 'Распознанный текст',
  'qr.open_link': 'Открыть',
  'qr.copy': 'Копировать',
  'qr.copied': 'Скопировано',

  'floor.role_target': 'цель',
  'floor.role_you': 'вы здесь',
  'floor.role_transit': 'транзит',
  'floor.role_parking': 'парковка',

  'pos.gps': 'GPS',
  'pos.anchor': 'по QR-якорю',
  'pos.none': 'позиция неизвестна',

  'common.close': 'Закрыть',
  'common.back': 'Назад',
  'common.done': 'Готово',

  'view.iso': 'Объём',
  'view.map': 'Карта',
  'iso.walk': 'Пройти маршрут (предпросмотр)',
  'iso.overview': 'Обзор',
  'iso.stack': 'Собрать',
  'iso.unstack': 'Разобрать',
  'iso.reset': 'Вид',
  'iso.hint': 'Тяните — поворот · колесо или щипок — масштаб',

  'connector.no_alternative':
    'На этой карте наверх ведёт только один переход — маршрут не изменился',
  'connector.row_label': 'Как подниматься между этажами',
  'connector.wheelchair': 'Без лестниц',
  'connector.stroller': 'С коляской',
  'alarm.title': 'ТРЕВОГА — идите к выходу по красной линии',
  'alarm.zones': 'опасных зон: {n}',
  'alarm.enable_sound': 'Включить звук',
  'alarm.sound_off': 'Без звука',
  'alarm.sound_on': 'Звук вкл',
  'alarm.blink_off': 'Не мигать',
  'alarm.blink_on': 'Мигание вкл',
  'connector.escalator': 'Эскалатор',
  'connector.escalator_note': 'Быстрее',
  'connector.lift': 'Лифт',
  'connector.lift_note': 'Ожидание, зато без ступеней',
  'connector.stairs': 'Лестница',
  'connector.stairs_note': 'Активно',

  'car.remember': 'Запомнить, где машина',
  'car.postcard': 'Открытка места машины (PNG с QR)',
  'car.return': 'Вернуться к машине',
  'car.forget': 'Забыть машину',
  'car.hint':
    'Отсканируйте код на колонне парковки или выберите зону. Автоопределение этажа — в приложении.',

  'update.ready': 'Доступна новая версия',
  'update.reload': 'Обновить',
  'unit.m': 'м',
  'unit.km': 'км',
  'unit.min': 'мин',
  'unit.lessMin': '<1 мин',

  'cat.gate': 'Гейт',
  'cat.check_in': 'Регистрация',
  'cat.security': 'Досмотр',
  'cat.baggage': 'Выдача багажа',
  'cat.terminal': 'Терминал',
  'cat.berth': 'Причал',
  'cat.deck': 'Палуба',
  'cat.cabin': 'Каюта',
  'cat.restaurant': 'Ресторан',
  'cat.muster': 'Пункт сбора',
  'cat.ship': 'Судно',
  'cat.factory': 'Производство',
  'cat.shop': 'Магазин',
  'cat.building': 'Здание',
  'cat.hall': 'Зал',
  'cat.room': 'Комната',
  'cat.workspace': 'Рабочее место',
  'cat.rest_area': 'Зона отдыха',

  'orient.board_straight': 'Лицом к щиту — и вперёд',
  'orient.board_right': 'Лицом к щиту — направо',
  'orient.board_left': 'Лицом к щиту — налево',
  'orient.board_back': 'Встаньте спиной к щиту — и вперёд',
  'orient.gate_straight': 'От щита — прямо, дальше поведём',
  'orient.gate_right': 'От щита выезд направо — поезжайте, дальше поведём',
  'orient.gate_left': 'От щита выезд налево — поезжайте, дальше поведём',
  'orient.gate_back': 'От щита — разворот, дальше поведём',
  'orient.first_leg': '{dist} до первого поворота',
  'orient.bind': 'Повернуться к щиту и привязать стрелку',
  'orient.bound': 'Стрелка привязана — верна, как ни поверните телефон',
  'orient.stale': 'Стрелка могла устареть — сверьтесь со щитом',
  'orient.walk_hint': 'Пройдите несколько шагов — уточним направление',
  'orient.go': 'Иду ✓',

  // AR-ведение (спека 13): способ движения выбирает пользователь; режимы
  // переключает наклон телефона, честный бейдж говорит, какой сенсор ведёт.
  'ar.choice_map': 'Карта и линия',
  'ar.choice_ar': 'AR-ведение',
  'ar.new': 'НОВОЕ',
  'ar.course_btn': 'По курсу',
  'ar.seg_map': 'Карта',
  'ar.seg_auto': 'Авто',
  'ar.seg_ar': 'AR',
  'ar.seg_split': 'Камера и карта',
  'ar.split_handle': 'Потянуть границу камеры и карты',
  'ar.manual': 'Ручной режим — авто вернётся сам',
  'ar.auto_back': 'Авто-режим снова включён',
  'ar.no_camera': 'Камера недоступна — ведём по карте',
  'ar.no_direction': 'Уточняем направление — пройдите несколько шагов',
  'ar.sensors_denied': 'Датчики недоступны — карта останется севером вверх',
  'ar.src_anchor': 'Якорь QR',
  'ar.src_course': 'По курсу GPS',
  'ar.src_compass': 'Компас',
  'ar.src_none': 'Нет направления',
  'ar.src_stale': 'могла устареть',
  'ar.safety_title': 'Спокойнее с опущенным телефоном',
  'ar.safety_body': 'Карта поведёт дальше — AR вернётся, когда поднимете.',
  'ar.retargeted': 'Ведём к новой цели',
  'ar.banner_evac': 'Эвакуация — не бегите',
  'ar.cardinal_n': 'С',
  'ar.cardinal_e': 'В',
  'ar.cardinal_s': 'Ю',
  'ar.cardinal_w': 'З',

  // «Прожектор» — оплаченное продвижение (ADR 0019). Слово «Реклама» и имя
  // заказчика показываются всегда: скрытая реклама запрещена (RekS §3).
  'promo.ad_label': 'Реклама',
  'promo.hide': 'Скрыть',
  'promo.paid_by': 'Размещено: {name}',
  'promo.by_owner': 'Размещено владельцем площадки',
  'promo.why_here': 'Почему я это вижу',
  'promo.chip': 'Реклама',
  'promo.ranking_title': 'Как устроен порядок результатов',
  'promo.ranking_intro':
    'Мы показываем, как формируется список и что в нём оплачено. Это требование ' +
    'закона к площадкам с рекламой — и просто честно по отношению к вам.',
  'promo.ranking_search':
    'Поиск. Сначала — совпадения по названию и товару, по близости к вам. ' +
    'Оплаченная строка не может обогнать точное совпадение: она встаёт после ' +
    'всех подходящих и всегда помечена словом «Реклама».',
  'promo.ranking_map':
    'Карта. Оплаченное выделение — контур и мягкое свечение. Оно не меняет ' +
    'ни название объекта, ни его категорию, ни расположение.',
  'promo.ranking_limit':
    'Пределы. Выделенным может быть не больше четверти объектов площадки: ' +
    'когда подсвечены все, не выделен никто.',
  'promo.ranking_route': 'Маршрут. Пока вы идёте, рекламы нет вовсе — как и в аварийном режиме.',
  'promo.ranking_back': 'Вернуться к карте',

  // Значки двери в карточке цели: главный вход и доступность (запрос 30.07).
  'door.badges': 'Об этом входе',
  'door.primary': 'Главный вход',
  'door.ramp': 'Пандус',
  'door.step_free': 'Без ступеней',
  'door.automatic': 'Автоматическая дверь',
  'door.width': 'Проём {cm} см',

  'search.open': 'Поиск',
  'search.placeholder': 'Магазин, товар или место…',
  'search.recent': 'Недавнее',
  'search.usually_here': 'обычно есть здесь',
  'search.not_found': 'Не нашли «{q}»',
  'search.report': 'Сообщить площадке',
  'search.report_sent': 'Передали владельцу площадки — спасибо!',

  // ─── Аварийный режим (G4, ADR 0009); drill.*/emergency.* — пакет strings/emergency ───
  'map.shelter_marker_aria': 'Укрытие {label} · {occ}',
  'map.shelter_marker_aria_plain': 'Укрытие {label}',

  // ── Вьюер «Terra» (дизайн modern-gis-logistics-application (4)) ──
  'app.tagline': 'Навигация последней мили внутри зданий',
  'app.tagline_full': '{brand} — Discover. Guide. Arrive.',
  'hdr.tagline': 'Навигация по территории',
  'map.empty_hint': 'Тапните по зданию или точке на карте',
  'map.view_3d': 'Объёмные здания (3D)',
  'map.view_2d': 'Плоский план (2D)',
  'basemap.label': 'Подложка карты',
  'basemap.dark_hint': 'Тёмная подложка',
  'basemap.cad_hint': 'Светлая CAD-подложка',
  'legend.title': 'Легенда территории',
  'legend.objects': 'Объекты',
  'legend.route': 'Маршрут',
  'legend.route_network': 'По дорогам площадки',
  'legend.route_direct': 'Вне дорог — по прямой',
  'legend.safety': 'Безопасность',
  'legend.safety_points': 'Выходы и точки сбора',
  'mall.error_venue': 'Карта этой площадки недоступна',
  'mall.error_not_mall': 'Эта площадка — не торговый центр',
  'mall.shops': 'магазинов',
  'mall.sheet_toggle': 'Развернуть список',
  'mall.cam_rotate': 'Поворот',
  'mall.cam_tilt': 'Наклон',
  'mall.cam_zoom': 'Масштаб',
  'mall.cam_gap': 'Зазор этажей',
  'mall.view_2d': 'Сверху',
  'mall.view_3d': 'Объём',
  'mall.view_2d_hint': 'Планы этажей плашмя, рядом друг с другом',
  'mall.near_title': 'Ближайшее',
  'mall.near_wc': 'Туалет',
  'mall.near_lift': 'Лифт',
  'mall.near_stairs': 'Эскалатор',
  'mall.near_food': 'Поесть',
  'mall.near_exit': 'Выход',
  'mall.mini_open': '{n} мест · открыть →',
  'mall.expand': 'разобрать',
  'mall.collapse': 'собрать',
  'mall.expand_hint': 'Показать все этажи насквозь — видно, что над чем',
  'mall.nav_pan': 'Двигать',
  'mall.nav_orbit': 'Вращать',
  'mall.hint_camera_3d': 'ЛКМ — двигать · ПКМ или Shift+ЛКМ — вращать · колесо — приблизить',
  'mall.hint_camera_orbit': 'Перетаскивание — вращать · колесо — приблизить',
  'mall.back_to_map': 'Карта',
  'mall.labels_name': 'Названия',
  'mall.labels_code': 'Номера',
  'mall.reset_view': 'Сбросить вид',
  'mall.levels': 'Уровни',
  'mall.directory': 'Каталог этажа',
  'mall.mode': 'РЕЖИМ ТЦ',
  'mall.all_levels': 'Все уровни',
  'mall.floor_stats': '{n} объектов на этаже',
  'mall.search_placeholder': 'Найти магазин на этаже…',
  'mall.empty': 'На этом этаже пусто',
  'a2b.kicker': 'Territory Wayfinding',
  'a2b.title': 'Маршрут A → B',
  'a2b.from': 'ОТКУДА (ТОЧКА А)',
  'a2b.to': 'КУДА (ТОЧКА Б)',
  'a2b.pick': 'Выберите цель…',
  'a2b.distance': 'ДИСТАНЦИЯ',
  'a2b.time': 'ВРЕМЯ В ПУТИ',
  'a2b.build': 'Построить на карте',
  'measure.kicker': 'GIS-измеритель',
  'measure.title': 'Замер расстояний и площадей',
  'measure.points': '{n} точек',
  'measure.hint': 'Кликайте по карте — точки замера',
  'measure.clear': 'Очистить',
  'measure.done': 'Готово',
  'qrpass.kicker_venue': 'QR территории',
  'qrpass.venue_open': 'QR-код территории',
  'qrpass.kicker': 'QR-навигация к цели',
  'qrpass.alt': 'QR-код со ссылкой на цель',
  'qrpass.scan_hint': 'Отсканируйте камерой смартфона — откроется карта с целью',
  'qrpass.copy': 'Ссылка',
  'qrpass.copied': 'Скопировано',
  'qrpass.share': 'Поделиться',
  // Схема пути из таблички (&r=): показывается, когда карта площадки не пришла.
  'sign.route_title': 'Путь к выходу с таблички',
  'sign.route_hint': 'Карта площадки не загрузилась — показан маршрут, записанный в QR',
  'sign.route_start': 'Вы здесь',
  'sign.route_exit': 'Выход',
  'unit.m2': 'м²',

  // Языковое меню (самоназвания — одинаковы во всех словарях)
  'lang.name_ru': 'Русский',
  'lang.name_en': 'English',
  'lang.name_et': 'Eesti',

  // Меню стилей карты (26.07.2026)
  'basemap.title': 'Стиль карты',
  'basemap.style_dark': 'Тёмный',
  'basemap.style_cad': 'Чертёжный',
  'basemap.style_liberty': 'Классический',
  'basemap.style_bright': 'Яркий',
  'basemap.style_fiord': 'Фьорд',
  'basemap.style_saved': 'Сохранённая карта',
  // Не зависим от одного провайдера карт (24.09.2026): ортофото и карта
  // Maa-amet — только рядом с Эстонией; «Схема» — совсем без сети.
  'basemap.style_ortho': 'Ортофото',
  'basemap.style_eemap': 'Карта Эстонии',
  'basemap.style_plain': 'Схема',
  'basemap.fallback_notice': 'Подложка карты недоступна — переключились на запасную',
  'floor.all': 'Все этажи',

  // Палитра поиска (референс (7), 26.07.2026)
  'search.tab_all': 'Всё',
  'search.tab_tenants': 'Арендаторы',
  'search.tab_buildings': 'Здания',
  'search.tab_infra': 'Инфраструктура',
  'search.open_now': 'Открыто сейчас',
  'search.quick_title': 'Быстрые запросы',
  'search.quick_food': 'Где поесть',
  'search.quick_warehouse': 'Склады и отгрузка',
  'search.quick_dock': 'Рампы для фур',
  'search.quick_entrance': 'Входы в здания',
  'search.quick_parking': 'Парковка',
  'search.quick_checkpoint': 'КПП и въезды',
  'search.quick_milk': 'Молоко',
  'search.quick_bread': 'Хлеб',
  'search.quick_checkout': 'Кассы',
  'search.quick_wc': 'Туалет',
  'search.tab_products': 'Товары',

  'shopping.kicker': 'Мой список',
  'shopping.title': 'Список покупок',
  'shopping.empty': 'Список пуст. Найдите товар в поиске и нажмите «+».',
  'shopping.add': 'В список',
  'shopping.remove': 'Убрать из списка',
  'shopping.clear': 'Очистить список',
  'shopping.tour_btn': 'Обойти всё ({n})',
  'shopping.tour_hide': 'Скрыть маршрут',
  'shopping.stops_n': '{n} остановок',
  'shopping.share': 'Поделиться списком',
  'shopping.share_copied': 'Ссылка скопирована',
  'shopping.promo_title': 'Сейчас в акции',
  'target.add_to_list': 'В список покупок',
  'target.in_list': 'В списке',
  'target.usually_here': 'Обычно есть здесь',

  'search.open_badge': 'Открыто',
  'search.closed_badge': 'Закрыто',
  'search.floor_n': '{n} эт.',
  'search.route_btn': 'Построить маршрут',
  'search.hint_open': 'открыть',
  'search.hint_route': 'маршрут',
  'search.found_n': 'Найдено: {n}',
  'search.smart_hint':
    'Поиск понимает опечатки, латиницу и неверную раскладку. Попробуйте «кафе», «склад» или «рампа».',

  // Подробная карточка (27.07.2026)
  'card.floor_n': '{n} этаж',
  'card.floors_n': 'Этажей: {n}',
  'card.tenants_n': 'Арендаторов: {n}',
  'card.tenants_title': 'Арендаторы',
  'card.how_to_find': 'Как найти внутри',
  'card.edit_link': 'Редактировать в кабинете',

  'search.all_objects': 'Все объекты',
  'catalog.title': 'Каталог',
  'catalog.tenants': 'Фирмы',
  'catalog.buildings': 'Здания',
  'catalog.hover_hint': 'Наведите на строку — объект подсветится на карте',
  'catalog.other': 'Прочее',
  'catalog.filter_placeholder': 'Фильтр: название или категория…',
  'card.photo_n': 'Фото {n}',
  'card.more': 'Подробнее',
  'card.less': 'Скрыть подробности',
  'floorstack.title': 'Этажи здания',
  'volume3d.kpi_floor': 'Этаж',
  'volume3d.kpi_area': 'Площадь',
  'volume3d.interior': 'Интерьер',
  'volume3d.outside': 'Снаружи',
  'volume3d.route_here': 'Маршрут построен внутри здания',
  'volume3d.tenants_on_floor': 'Арендаторы этажа',
  'volume3d.kpi_cabin': 'Каюта',
  'cabin.interior': 'Внутренняя',
  'cabin.oceanview': 'С окном на море',
  'cabin.balcony': 'С балконом',
  'cabin.suite': 'Люкс',
  'cabin.port': 'Левый борт',
  'cabin.starboard': 'Правый борт',
  'volume3d.search': 'Поиск арендатора или каюты',
  'volume3d.kpi_guests': 'Мест',
  'volume3d.route_len': 'Идти {m} м по этажу',
  'volume3d.route_none': 'Пройти по этажу нельзя — уточните маршрут на карте',
  'volume3d.all': 'Все',
  'volume3d.search_short': 'Поиск',
  'volume3d.search_empty': 'Ничего не нашлось — попробуйте другое слово',
  'volume3d.search_more': 'Показано {shown} из {total}',
  'volume3d.search_count': 'Найдено: {n}',
  'mall.all_short': 'Все этажи',
  'volume.choose': 'Выбрать вид объёма',
  'volume.kind_iso': 'Объём',
  'volume.kind_iso_hint': 'Вся площадка, этажи рядом',
  'volume.kind_stack': 'Этажерка',
  'volume.kind_stack_hint': 'Этажи здания стопкой на карте',
  'volume.kind_three': 'Объём 3D',
  'volume.kind_three_hint': 'Этаж изнутри, с арендаторами',
  'volume3d.open': 'Объём 3D',
  'volume3d.title': 'Объёмный вид здания',
  'volume3d.floor_n': '{n} этаж',
  'volume3d.explode': 'Разложить этажи',
  'volume3d.reset': 'Сбросить вид',
  'volume3d.downgraded': 'Упростили картинку, чтобы шло плавно на этом устройстве.',
  'volume3d.failed': 'Объёмный вид не запустился на этом устройстве — доступен плоский «Объём».',
  'floorstack.open': 'Объём · {n} эт.',
  'floorstack.vacant': 'На {n} этаже арендаторов нет',
  'floorstack.hint': 'Тап по этажу на карте или чипу — выбор этажа',
  // ── hazards: точечные опасности, городская тревога (24.09.2026); staff.* — пакет strings/staff ──
  'route.detour': 'Маршрут в обход: {kind} · +{m} м',
  'route.detour_floor': 'Маршрут в обход: {kind}, этаж {level} · +{m} м',
  'route.detour_no_m': 'Маршрут в обход: {kind}',
  'route.detour_floor_no_m': 'Маршрут в обход: {kind}, этаж {level}',
  'route.detour_zone': 'опасная зона',
  'route.unreachable': 'К цели не пройти — {kind}',
  'alarm.city_label': 'Город',
  'alarm.title_short': 'ТРЕВОГА',
  'alarm.city_elsewhere': 'Городская тревога в другом районе',
  'alarm.city_elsewhere_out': 'Городская тревога в другом районе — вы вне зоны',
  'alarm.city_elsewhere_open': 'Подробнее',
  // Пометка учений в городском баннере; эстонское «ÕPPUS» — на любом языке (сигнал городской).
  'alarm.drill_tag': 'УЧЕНИЯ · ÕPPUS',
  'alarm.venue.fire': 'Пожар — идите к выходу по маршруту на карте',
  'alarm.venue.evac': 'Эвакуация — идите к выходу по маршруту на карте',
  'alarm.venue.flood': 'Наводнение — поднимитесь на верхние этажи по маршруту на карте',
  'alarm.venue.danger': 'Опасность — следуйте указаниям персонала',
  'alarm.venue.shelter': 'Оставайтесь в здании — отойдите от окон',
  'alarm.city.air': 'Воздушная тревога — пройдите в укрытие',
  'alarm.city.evac': 'Эвакуация района — следуйте указаниям служб',
  'alarm.levels': 'Тревога: этаж {name}',
  'alarm.checked_ago': 'Проверено {min} мин назад',
  'alarm.checked_now': 'Проверено только что',
  'alarm.offline': 'Нет связи — показан последний известный сигнал',
  'alarm.self_title': 'Вы включили сами — официального сигнала нет',
  'alarm.relay_title': 'Тревогу передали с другого телефона — подлинность не проверена',
  // ── sos: всегда видимые аварийные кнопки, офлайн-статус, публичные укрытия (24.09.2026) ──
  'sos.button': 'SOS',
  'sos.sheet_title': 'Что нужно?',
  'sos.shelter': 'Укрытие',
  'sos.exit': 'Выход',
  'sos.call112': '112',
  'sos.disclaimer': 'Эти кнопки никого не оповещают — только показывают дорогу вам самим.',
  'sos.status_offline': 'Нет связи — карта работает офлайн',
  'sos.status_checked': 'Официального сигнала нет · проверено {n} мин назад',
  'sos.status_unknown': 'Официального сигнала нет',
  'shelters.geo_asking': 'Определяем ваше место, чтобы показать ближайшее укрытие',
  'shelters.geo_denied': 'Нет доступа к геопозиции — список от центра города',
  'shelters.straight_line': 'прямая линия — дорога может быть длиннее',
  'shelters.route_btn': 'Маршрут',
  'shelters.none': 'Укрытия поблизости не найдены',
  'cityalert.air': 'Воздушная тревога',
  'cityalert.evac': 'Эвакуация',
  'cityalert.drill_badge': 'УЧЕНИЯ · ÕPPUS',
  'cityalert.finding_you': 'Определяем ваше место, чтобы показать путь к ближайшему укрытию',
  // ── hazard-map: обход опасностей обычным маршрутом, зона опасности на карте (24.09.2026) ──
  'hazard.kind.fire': 'Пожар',
  'hazard.kind.smoke': 'Задымление',
  'hazard.kind.flood': 'Затопление',
  'hazard.kind.danger': 'Опасность',
  'hazard.kind.closed': 'Проход закрыт',
} as const
